export default function ContactSection() {
  return (
    <section id="contact" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-1 h-6 bg-secondary-500 rounded-full"></span>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">投稿爆料</h2>
          <span className="text-xs text-foreground-400">你的线索值得被看见</span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div className="space-y-5">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              手握独家爆料却无处发声？911吃瓜网为每一位热心读者提供开放的投稿渠道。无论是娱乐八卦、社会热点还是网红动态，只要是真实可信的第一手热门爆料，都有可能成为明天的头条。我们承诺对所有投稿严格保密，来稿必回。
            </p>
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-primary-600 text-lg"></i>
                </div>
                <div>
                  <p className="text-xs text-foreground-400">投稿邮箱</p>
                  <p className="text-sm font-medium text-foreground-800">tips@911chigua.com</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-wechat-line text-accent-600 text-lg"></i>
                </div>
                <div>
                  <p className="text-xs text-foreground-400">微信客服</p>
                  <p className="text-sm font-medium text-foreground-800">911chigua_official</p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-background-100 rounded-xl p-6 border border-background-200/70">
            <div className="space-y-4">
              <div>
                <label className="block text-xs font-medium text-foreground-600 mb-1.5">爆料类型</label>
                <select className="w-full px-3 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-700">
                  <option>娱乐八卦</option>
                  <option>社会热点</option>
                  <option>网红动态</option>
                  <option>其他类型</option>
                </select>
              </div>
              <div>
                <label className="block text-xs font-medium text-foreground-600 mb-1.5">爆料简述</label>
                <textarea
                  className="w-full px-3 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-700 resize-none"
                  rows={3}
                  placeholder="请简要描述你的爆料内容..."
                ></textarea>
              </div>
              <div className="honeypot-wrap">
                <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              </div>
              <button
                type="button"
                className="w-full py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-colors text-sm"
              >
                提交爆料
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}